// ============================================================
// COUNT STRIP — the masthead's numbers, each a button.
//   total · Mine n · Theirs n · Holding n · New n [· n ?]
// Mine / Theirs / Holding toggle the board's court filter (the existing
// chips reflect and clear it); New reveals the rail; total clears every
// filter. Court colours, not lanes: Mine = "Your move" amber, Theirs =
// "Their move" blue, Holding = "Parked" slate, New = the rail's accent.
// Zero counts dim, never hide. Pure presentation; no state of its own.
// ============================================================

const SEGMENTS = [
  { key: 'mine', label: 'Mine', court: 'Mine' },
  { key: 'theirs', label: 'Theirs', court: 'Theirs' },
  { key: 'holding', label: 'Holding', court: 'Holding' },
];

export default function CountStrip({ counts, activeCourts = [], onCourt, onNew, onTotal }) {
  const c = counts || { total: 0, new: 0, mine: 0, theirs: 0, holding: 0, unset: 0 };
  const seg = (key, label, n, { active = false, onClick, title } = {}) => (
    <button key={key} type="button"
      className={`Watch-count Watch-count--${key}${active ? ' Watch-count--on' : ''}${n === 0 ? ' Watch-count--zero' : ''}`}
      aria-pressed={onClick && key !== 'total' && key !== 'new' ? active : undefined}
      title={title} onClick={onClick} data-testid={`count-${key}`}>
      <span className="Watch-count-n">{n}</span>
      {label && <span className="Watch-count-label">{label}</span>}
    </button>
  );
  return (
    <span className="Watch-counts" role="group" aria-label="Board counts">
      {seg('total', '', c.total, { onClick: () => onTotal?.(), title: 'Open items · clear filters' })}
      {SEGMENTS.map(s => seg(s.key, s.label, c[s.key], { active: activeCourts.includes(s.court), onClick: () => onCourt?.(s.court), title: `Filter court ${s.court}` }))}
      {seg('new', 'New', c.new, { onClick: () => onNew?.(), title: 'Show the NEW rail' })}
      {c.unset > 0 && seg('unset', '?', c.unset, { title: 'Open, triaged, no court set' })}
    </span>
  );
}
